export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.f7d078e7.worker.js");
}
